import { render, staticRenderFns } from "./Contribution.vue?vue&type=template&id=0712303a&"
import script from "./Contribution.vue?vue&type=script&lang=js&"
export * from "./Contribution.vue?vue&type=script&lang=js&"
import style0 from "./Contribution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/_AzureDevOps/Kali_easyfert/CMS/Web/easyfert/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VForm,VLayout,VSelect,VSlider,VSwitch,VTextField})
